"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupedBars = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
exports.GroupedBars = function (_a) {
    var groupedValues = _a.groupedValues, xScaleSubGroup = _a.xScaleSubGroup, xScaleGroup = _a.xScaleGroup, colorScale = _a.colorScale, yScale = _a.yScale;
    return (react_1.default.createElement(react_1.default.Fragment, null, groupedValues.map(function (v) {
        var _a;
        return (react_1.default.createElement("rect", { width: xScaleSubGroup.bandwidth(), x: ((_a = xScaleSubGroup(v.subGroupID)) !== null && _a !== void 0 ? _a : 0) +
                (xScaleGroup.step() - xScaleGroup.bandwidth()) / 2, fill: colorScale({ ID: v.subGroupID }), y: v.y && v.y < 0
                ? yScale(v.y) - Math.abs(yScale(0) - yScale(v.y))
                : yScale(v.y), height: Math.abs(yScale(0) - yScale(v.y)), key: v.subGroupID + "-rect", className: "FOS_Bar_Rect" }));
    })));
};
